import NotFooterLayout from "layouts/NotFooterLayout";
import CreateCampaign from "components/Campaign/CreateCampaign";

function CreateCampaignPage() {
  return (
    <>
      <NotFooterLayout namePage="เพิ่มข่าวสาร / โปรโมชั่น"  >
        <div className="layout-content">
          <CreateCampaign />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateCampaignPage;
